import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Paper, Typography } from '@material-ui/core';

import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    explanation: {
        marginTop: '1rem',
        padding: '.5rem'
    }
}));

// 説明
function Explanation(){
    const classes = useStyles();

    const igonFlag = useSelector(state => state.igon.igonFlag);

    return(
        <Paper className={classes.explanation}>
            <Typography>
                {
                    (() => {
                        if(igonFlag){
                            return (
                                <>
                                相続・遺贈する全ての財産の情報をご入力ください。<br />
                                </>
                            );
                        }
                    })()
                }
                入力が完了しましたら、<Typography color="error" component="span">入力した財産を登録する</Typography>をクリックしてください。<br/>
                さらに財産を入力される場合は、<Typography color="error" component="span">メニューから保有する財産を選ぶ</Typography>をクリックして進んでください。<br />
                {
                    (() => {
                        if(igonFlag){
                            return (
                                <>
                                全ての財産を入力されたら、<Typography color="error" component="span">完了して財産目録と自筆遺言書を作成する</Typography>をクリックしてください。
                                </>
                            );
                        }else{
                            return (
                                <>
                                全ての財産を入力されたら、<Typography color="error" component="span">完了して財産目録を作成する</Typography>をクリックしてください。
                                </>
                            );
                        }
                    })()
                }
            </Typography>
        </Paper>
    );
}

export default Explanation
